// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1RjJ5","range":"MonthRangeSwitch_range__14DU_","disabled":"MonthRangeSwitch_disabled__XJ795"};